import { Controller } from "@hotwired/stimulus"
import { bootstrapTextareaMarkdown } from "@can3p/headless-mde/headless";

export default class extends Controller {
  static values = {
    upload: Boolean,
  }

  connect() {
    let textarea = this.element.querySelector("textarea")
    const { trigger, dispose, cursor } = bootstrapTextareaMarkdown(textarea, {
      options: {
        enableLinkPasteExtension: false,
      }
    });

    this.dispose = dispose

    let runCmd = function(cmd, e) {
      e.preventDefault()
      trigger(cmd)
    }

    if (this.uploadValue) {
      let upload = this.element.querySelector("#new_message_file_upload")

      const uploadFile = async(file) => {
        const formData = new FormData();

        formData.append('file', file);

        return fetch('/controls/form/upload_media', {
            method: 'POST',
            body: formData
          })
          .then((response) => response.json())
          .then((response) => response.uploaded_url)
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      const uploadFiles = (files) => {
        textarea.focus();
        for (let file of files) {
          if (!file.type.startsWith('image/')){ continue }

          if (cursor.position.line.text) {
            cursor.insert('\n'); // wrap to next line if some line is not empty
          }
          
          const loadingPlaceholder = `[uploading (${file.name})...${+new Date()}]`;
          cursor.insertAndScrollIntoView(loadingPlaceholder);

          uploadFile(file).then((url) => {
            cursor.replace(loadingPlaceholder, `![${file.name}](${url})`);
          })
        }
      }

      const handler = () => {
        uploadFiles(upload.files ?? [])
      };

      upload.addEventListener('change', handler, false);

      this.element.addEventListener('dragenter', function(e) {
        e.stopPropagation()
        e.preventDefault()
      }, false)

      this.element.addEventListener('dragover', function(e) {
        e.stopPropagation()
        e.preventDefault()
      }, false)

      this.element.addEventListener('drop', function(e) {
        e.stopPropagation()
        e.preventDefault()

        const dt = e.dataTransfer
        const files = dt.files

        uploadFiles(files)
      }, false)

      textarea.addEventListener('paste', (e) => {
        uploadFiles(e.clipboardData.files)
      }, false)
    }


    for (let btn of this.element.querySelectorAll("[data-command]")) {
      let cmd = btn.dataset.command

      btn.addEventListener("click", runCmd.bind(null, cmd), false)
    }
  }

  disconnect() {
    this.dispose()
  }
}
